<div class="btn-group export-dropdown">
  <button type="button" class="btn-export dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
    <i-lucide name="download" size="18"></i-lucide>
    {{ label }}
  </button>
  <ul class="dropdown-menu export-menu text-nowrap">
    <ng-container *ngFor="let grupo of grupos">
      <li class="export-grupo" role="presentation">{{ grupo.titulo }}</li>

      <li *ngFor="let option of grupo.opcoes" class="export-options">
        <button
          class="btn btn-sm btn-export-intern"
          [ngClass]="'export-' + option.cor"
          (click)="exportType.emit(option.type)">
          <span class="export-selo" aria-hidden="true">
            <ng-container *ngIf="option.selo; else seloIcone">{{ option.selo }}</ng-container>
            <ng-template #seloIcone>
              <i-lucide [name]="option.icon" size="16"></i-lucide>
            </ng-template>
          </span>
          {{ option.label }}
        </button>
      </li>
    </ng-container>
  </ul>
</div>
